import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import Button from '@mlb/react-patterns/v4/components/Button/button';
import ModalContent from '@mlb/react-patterns/v4/components/Modal/ModalContent/modalContent';
import { ModalTypes } from '../AtBat/atbat.style';
import GDBREAKPOINTS, { MODAL_BREAKPOINT_MOBILE } from '@gameday/components/themes/breakpoints';
import { ModalContainer } from '@mlb/react-patterns/v4/components/Modal/modal.style';

const SM_MAX = `${GDBREAKPOINTS.SM_MAX}`;

const {
    mlbWhite,
    mlbBlack,
    mlbGrey3,
    mlbGrey5
} = COLORS;

const { GAME_OVER, VERTICAL, FIELDVISION, FIELDVISION_VERTICAL, ATBAT, ATBAT_VERTICAL, PORTAL_LESS, SCOREBOARD_VERTICAL, NO_OKTA, INTERSTITIAL } = ModalTypes || {};

export const CustomModalContent = styled(ModalContent).attrs({
    'data-mlb-test': 'custom-modal-content'
})`
    font-family: var(--gameday-primary-font);
    background: var(--gameday-overlay-background-color);
    width: 528px;
    border-radius: var(--gameday-border-radius);
    margin: var(--gameday-section-padding-sm) 0;
    max-width: 528px;
    min-width: ${GDBREAKPOINTS.SM};
    overflow: hidden;
    overflow-y: auto;
    height: auto;
    max-height: calc(100% - calc(var(--safe-area-inset-top) + 82px));


    @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
        width: 80%;
    }
`;
export const FieldVisionModalContent = styled(CustomModalContent)`
    width: 375px;
    max-width: 375px;
`;
export const FieldVisionExploreModalContent = styled(FieldVisionModalContent)`
    min-width: unset;
    height: 100%;
    overflow-y: hidden;
    max-height: 788px;
`;

export const CustomVerticalModalContent = styled(ModalContent).attrs({
    'data-mlb-test': 'custom-vertical-modal-content'
})`
  font-family: var(--gameday-primary-font);
  height: calc(100% - calc(var(--safe-area-inset-top) + 32px));
  width: 100%;
  border-top-left-radius: var(--gameday-border-radius);
  border-top-right-radius: var(--gameday-border-radius);
  background: var(--gameday-background-color);
`;

export const FieldVisionVerticalExploreModalContent = styled(CustomVerticalModalContent)`
    height: calc(100% - var(--safe-area-inset-top));
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
`;

export const ScoreboardModalContent = styled(CustomModalContent)`
    z-index:111;
    width: 375px;
    max-width: 375px;
    min-width: 375px;
    height: auto;
    max-height: calc(100vh - 150px);
    margin:0;
    border: 1px solid var(--gameday-divider-color);
    display: flex;
    flex-direction: column;
    overflow-y: hidden;

    @media (max-width: ${SM_MAX}) {
        max-height: calc(100vh - 50px);
    }

    @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        max-height: calc(100% - var(--safe-area-inset-top) - var(--safe-area-inset-bottom) - 50px);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        height: calc(100vh - 150px);
    }
`;

export const InterstitialModalContent = styled(ModalContent).attrs({
    'data-mlb-test': 'custom-modal-content'
})`
    font-family: var(--gameday-primary-font);
    background: var(--gameday-overlay-background-color);
    width: 528px;
    border-radius: var(--gameday-border-radius);
    margin: var(--gameday-section-padding-sm) 0;
    max-width: 528px;
    min-width: ${GDBREAKPOINTS.SM};
    overflow: auto;
    height: auto;
    max-height: calc(100% - calc(var(--safe-area-inset-top) + 82px));


    @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
        min-width: auto;
        width: calc(100vw - 32px);
    }
`;

export const ContentWrapper = styled.div`
    width: 100%;
    max-width: 480px;
    overflow-y: auto;
    overscroll-behavior-y: contain;
    padding: var(--gameday-section-padding);
    box-sizing: content-box;

    @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
        padding: var(--gameday-section-padding-sm);
    }

    ${({ type }) => {
        if (type === VERTICAL) {
            return `
                padding: var(--gameday-section-padding-sm);
            `;
        }

        if (type === FIELDVISION) {
            return `
                padding: var(--gameday-section-padding) 0 0 0;
                padding-top: 20px;
                height:100%;
            `;
        }

        if (type === FIELDVISION_VERTICAL) {
            return `
                padding: 20px 0 0 0 !important;
                height:100%;
                max-width: unset;

            `;
        }

        if (type === ATBAT_VERTICAL) {
            return `
                padding-top: 0 !important;

                > button {
                    position: absolute;
                    top: 19px;
                    right: 18px;
                    z-index: 115;
                }
            `;
        }

        if (type === SCOREBOARD_VERTICAL) {
            return `
                padding: 0 !important;
                max-width: 100%;
                width: 100%;
                overflow-y: hidden;
                height: 100%;
                display: flex;
                flex-direction: column;
            `;
        }

        if (type === ATBAT) {
            return `

            `;
        }

        if (type === GAME_OVER) {
            return `
            `;
        }

        if (type === INTERSTITIAL) {
            return `
                width: auto;
                padding: 0;
                max-width: 100%;
                @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
                    padding: 0;
                }
            `;
        }

        if (type === NO_OKTA) {
            return `
                max-width: 327px;
                position: relative;
                padding-right: 0 !important;
                padding-left: 0 !important;
            `;
        }

        if (type === PORTAL_LESS) {
            return `
                padding: 0;
                max-width: 100%;
                width: 100%;
                overflow-y: hidden;
                display: flex;
                flex-direction: column;
            `;
        }
    }};

`;

export const CloseButton = styled(Button)`
    z-index: 2;
    padding-left:0;
    padding-right:0;
    border-radius: 0;
    background: transparent;
    float: right;
    margin-top:-8px;

    svg {
        stroke: none;
    }
    &:hover {
        background-color: var(--gameday-hover-close-color);
    }

    ${({ type }) => {
        if (type === VERTICAL || type === FIELDVISION_VERTICAL || type === SCOREBOARD_VERTICAL) {
            return `
                position: absolute !important;
                z-index: 10;
                right: var(--gameday-section-padding-sm);
                top: var(--gameday-section-padding-sm);
            `;
        }

        if (type === ATBAT_VERTICAL || type === ATBAT) {
            return `
                float: right;
                margin-top: -10px;
            `;
        }
    }};

    ${({ type, isWhite }) => {
        if (type === FIELDVISION) {
            return `
                position: absolute;
                right: 0;
                z-index: 10;
                margin-top: -6px;
                margin-right: var(--gameday-section-padding);
                background-color: transparent;
                color: ${mlbGrey3};
                &:hover {
                    background-color: transparent;
                }
            `;
        }
        if (type === VERTICAL) {
            return `
                position: absolute;
            `;
        }
        if (type === SCOREBOARD_VERTICAL) {
            return `
                position: static;
                background-color: transparent;
                &:hover {
                    background-color: transparent;
                }
            `;
        }
        if (type === NO_OKTA) {
            return `
                position: absolute;
                top: 12px;
                right: 4px;
                height: 22px;
                width: 22px;
                border-radius: 50%;
                border: 1px solid ${mlbGrey5};
                background:${mlbGrey5};
                &:hover {
                    background-color: ${mlbGrey5};
                    svg {
                        fill: ${mlbWhite};
                        path {
                            fill: ${mlbWhite};
                        }
                    }
                }
                svg {
                    padding-top: 2px;
                    fill: ${mlbWhite};
                    width: 10px;
                    height: 10px;
                    path {
                        fill: ${mlbWhite};
                    }
                }
            `;
        }
    }};
`;

export const BackdropWrapper = styled.div`
    background: ${mlbBlack};
    opacity: var(--gameday-overlay-opacity);
    width: 100%;
    height: 100%;
`;

export const PortalLessBackdropWrapper = styled(BackdropWrapper)`
    z-index:111;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    -webkit-tap-highlight-color: transparent;
    position: absolute;
    height: calc(100vh - 50px);
`;

export const ModalWrapper = styled.div`
    ${({ $usePortalLess }) => {
        if ($usePortalLess) {
            return `
                position: absolute;
                width: 100%;
                height: auto;
                top: 50px;

                ${ModalContainer} {
                    position: static;
                    left: auto;
                    bottom: auto;
                    right: auto;
                    width: 100%;
                }
             `;
        } else {
            return '';
        }
    }};
`;
